import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DpFormModule, DpFormNavigationService, DpFormService, DpModalService, DpNotFoundComponent } from '@docpath/webcomponents';

import { RoutingPath } from './constants/routing-path';
import { CloudComponent } from './pages/cloud/cloud.component';
import { AlertRulesComponent } from './pages/configuration/alert-rules/alert-rules.component';
import { AliasComponent } from './pages/configuration/alias/alias.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { EnginesComponent } from './pages/configuration/engines/engines.component';
import { FailedJobsComponent } from './pages/configuration/failed-jobs/failed-jobs.component';
import { GeneralComponent } from './pages/configuration/general/general.component';
import { SelfMaintenanceComponent } from './pages/configuration/self-maintenance/self-maintenance.component';
import { ServicesComponent } from './pages/configuration/services/services.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { MonitoringComponent } from './pages/monitoring/monitoring.component';
import { LogComponent } from './pages/statistics/log/log.component';
import { StatisticsComponent } from './pages/statistics/statistics.component';
import { FormGuard } from './shared/guards/form.guard';
import { LoginGuard } from './shared/guards/login.guard';
import { NotFoundGuard } from './shared/guards/not-found.guard';

const routes: Routes = [
  { path: RoutingPath.PATH_EMPTY, pathMatch: 'full', redirectTo: RoutingPath.PATH_HOME },
  { path: RoutingPath.PATH_LOGIN, canActivate: [LoginGuard], component: LoginComponent },
  { path: RoutingPath.PATH_CLOUD, component: CloudComponent },
  {
    path: RoutingPath.PATH_EMPTY, canActivate: [LoginGuard], children: [
      { path: RoutingPath.PATH_HOME, canActivate: [LoginGuard], component: HomeComponent },
      { path: RoutingPath.PATH_STATISTICS, canActivate: [LoginGuard], component: StatisticsComponent },
      { path: RoutingPath.PATH_STATISTICS_WITH_PARAMETER, canActivate: [LoginGuard], component: StatisticsComponent },
      { path: RoutingPath.PATH_STATISTICS_LOGS, canActivate: [LoginGuard], component: LogComponent },
      { path: RoutingPath.PATH_MONITORING, canActivate: [LoginGuard], component: MonitoringComponent },
      {
        path: RoutingPath.PATH_CONFIGURATION, canActivate: [LoginGuard], component: ConfigurationComponent, children: [
          { path: RoutingPath.PATH_EMPTY, redirectTo: RoutingPath.PATH_GENERAL, pathMatch: 'full' },
          { path: RoutingPath.PATH_GENERAL, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: GeneralComponent },
          { path: RoutingPath.PATH_SERVICES, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: ServicesComponent },
          { path: RoutingPath.PATH_ALERT_RULES, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: AlertRulesComponent },
          { path: RoutingPath.PATH_FAILED_JOBS, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: FailedJobsComponent },
          { path: RoutingPath.PATH_ALIAS, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: AliasComponent },
          { path: RoutingPath.PATH_ENGINES, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: EnginesComponent },
          { path: RoutingPath.PATH_SELF_MAINTENANCE, canActivate: [LoginGuard], canDeactivate: [FormGuard], component: SelfMaintenanceComponent }
        ]
      }
    ]
  },
  { path: RoutingPath.PATH_404, component: DpNotFoundComponent },
  { path: RoutingPath.PATH_ANY, canActivate: [NotFoundGuard], component: DpNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    DpFormModule
  ],
  exports: [RouterModule],
  providers: [
    DpModalService,
    DpFormService,
    DpFormNavigationService,
    FormGuard,
    provideHttpClient()
  ]
})
export class AppRoutingModule { }
